import {AbstractStandardPanel} from "@/scenes.ui/abstract-standard-panel";
import {Keys} from "@/constants/key";

export class BigStandardPanel extends AbstractStandardPanel {

    protected getWindowKey(): string {
        return Keys.UI_WINDOW_BIG;
    }

    protected getXButtonY(): number {
        return -340;
    }

    protected getXButtonX(): number {
        return 234;
    }

    protected getTitleY(): number {
        return -310;
    }

    protected getCloseButtonX(): number {
        return 0;
    }

    protected getCloseButtonY(): number {
        return 180;
    }

}
